import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="autosave"
export default class extends Controller {
  static targets = [ "field" ]
  static values = {
    interval: { type: Number, default: 20000 } // milliseconds
  }
  connect() {
    if (!this.hasFieldTarget) {
      console.warn("Autosave controller: 'field' target not found. Autosave will not function.");
      return;
    }

    this.formElement = this.element; // The controller is attached to the form
    this.monitoredField = this.fieldTarget;
    this.lastSavedValue = this.monitoredField.value;
    this.isDirty = false;

    // Bind event listener methods to 'this'
    this.handleInput = this.handleInput.bind(this);
    this.attemptSave = this.attemptSave.bind(this);

    this.monitoredField.addEventListener("input", this.handleInput);
    this.startPolling();
    console.log(`Autosave controller connected. Polling every ${this.intervalValue / 1000}s.`);
  }

  disconnect() {
    this.stopPolling();
    if (this.hasFieldTarget) {
      this.monitoredField.removeEventListener("input", this.handleInput);
    }
    console.log("Autosave controller disconnected.");
  }

  handleInput() {
    this.isDirty = true;
  }

  startPolling() {
    if (this.timer) return; // Already polling
    this.timer = setInterval(this.attemptSave, this.intervalValue);
  }

  stopPolling() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  attemptSave() {
    if (this.isDirty && this.monitoredField.value !== this.lastSavedValue) {
      console.log("Autosave: Changes detected, submitting form...");
      this.submitForm();
      this.lastSavedValue = this.monitoredField.value;
      this.isDirty = false; // Reset dirty flag after attempting submission
    } else {
      // console.log("Autosave: No changes to save or field value unchanged.");
    }
  }

  submitForm() {
    // Ensure commit_and_stay parameter is present
    let commitInput = this.formElement.querySelector("input[type='hidden'][name='commit_and_stay']");
    if (!commitInput) {
      commitInput = document.createElement("input");
      commitInput.type = "hidden";
      commitInput.name = "commit_and_stay";
      this.formElement.appendChild(commitInput);
    }
    commitInput.value = "true";

    // Use form.requestSubmit() for a standard submission that respects Turbo
    // and triggers validations.
    if (typeof this.formElement.requestSubmit === "function") {
      this.formElement.requestSubmit();
    } else {
      // Fallback for older browsers or environments
      this.formElement.submit();
    }
    // The hidden input will persist until the form is re-rendered or page changes.
    // This is generally fine. If the user manually submits with a different button
    // that doesn't set commit_and_stay, that button's value usually takes precedence
    // for `form.button` or `input type=submit`.
  }
}
